import { render, staticRenderFns } from "./CornerDownRightIcon.vue?vue&type=template&id=3e6c3f9b"
import script from "./CornerDownRightIcon.vue?vue&type=script&lang=ts"
export * from "./CornerDownRightIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports